import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { InformacionProcesoCorto } from "../../components/ProcesosDeCalificacion/InformacionProcesoCorto";
import { Toolbar } from "../../layout/Toolbar/Toolbar";
import { Modal } from "../../components/Otros/Modal";
import {
  cargarDatosProceso,
  cargarListarSinCorreo,
  cargarNoNotificados,
  cargarNotificados,
  cargarProcesoActivo,
  enviarNotificaciones,
} from "../../utils/Datos";
import { InformacionParticipanteProceso } from "../../components/Otros/InformacionParticipanteProceso";
import { VerificarNotificacion } from "../../components/ProcesosDeCalificacion/VerificarNotificacion";

export const Notificaciones = () => {
  const [datosProceso, setdatosProceso] = useState(null);
  const [datosSinCorreo, setdatosSinCorreo] = useState(null);
  const [datosNotificados, setdatosNotificados] = useState(null);

  const [cantidadNotificados, setcantidadNotificados] = useState(0);
  const [cantidadNoNotificados, setcantidadNoNotificados] = useState(0);

  const [notificando, setnotificando] = useState(false);
  //let [searchParams, setSearchParams] = useSearchParams();
  //let idProcess = searchParams.get("idProcess");
  /*
  const { idProcess } = useParams();
 
  console.log(idProcess);
  if (idProcess === null || idProcess === "") {
    Swal.fire({
      title: "Error",
      text: "No se ha seleccionado un proceso para ser visualizado.",
      icon: "error",
    });
  }*/

  
  const [idProcess, setidProcess] = useState(null);

  useEffect(() => {
    cargarProcesoActivo().then((datos) => {
      setidProcess(datos.id_process);
    });
  }, []);

  //activo?
  useEffect(() => {
    if (idProcess !== null) {
      cargarDatosProceso(idProcess).then((proceso) => {
        if (proceso === null || proceso.status === "BAD_REQUEST") {
          Swal.fire({
            icon: "error",
            title: "Error...",
            text: proceso.errors[0],
          });
        } else {
          setdatosProceso(proceso);
        }
      });

      /*
      cargarListarSinCorreo(idProcess).then((sinCorreo) => {
        setdatosSinCorreo(sinCorreo);
        if (sinCorreo!=null) {
          setcantidadNoNotificados(sinCorreo.length);
        }
        
      });*/
      cargarNoNotificados(idProcess).then((noNotificados)=>{
        setdatosSinCorreo(noNotificados);
        if (noNotificados!=null) {
          setcantidadNoNotificados(noNotificados.length);
        }
      });

      cargarNotificados(idProcess).then((notificados) => {
        setdatosNotificados(notificados);
        if (notificados!=null) {
          setcantidadNotificados(notificados.length);
        }
        
      });
    }
  }, [idProcess]);

  let toolbarEnlaces = [
    {
      muted: "true",
      to: "/",
      title: "Home",
      bullet: "false",
    },
    {
      muted: "true",
      to: "",
      title: "",
      bullet: "true",
    },
    {
      muted: "false",
      to: null,
      title: "PROCESO DE NOTIFICACIONES",
      bullet: "false",
    },
  ];

  const [datos, setdatos] = useState(<div>inicial</div>);
  const [first, setfirst] = useState(null);

  const [infoParticipante, setinfoParticipante] = useState(<></>);

  const handleVer = (e) => {
    console.log(e.target.dataset.id);
    setinfoParticipante(
      <>
        <InformacionParticipanteProceso
          idProcess={idProcess}
          id_participant={e.target.dataset.id}
          mostrarTitulo={false}
        />
        <VerificarNotificacion id_participant={e.target.dataset.id} />
      </>
    );
  };

  const handleNotificar= (e)=>{
      setnotificando(true);
      if (idProcess!=null) {
        enviarNotificaciones(idProcess).then((respuesta)=>{
          if (respuesta.status) {
              Swal.fire({
                icon:'success',
                title:'Correcto',
                text:`Notificaciones enviadas con éxito`
              }).then((okay) => {
                if (okay) {
                  window.location.href = "/notificaciones";
                }
              });
              setnotificando(false);
          }else{
            Swal.fire({
              icon:'error',
              title:'Error',
              text:`Ha ocurrido un error ${respuesta.errores}`
            })
            setnotificando(false);
          }
        });
      }
      
  }

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Toolbar title="PROCESO DE NOTIFICACIONES" enlaces={toolbarEnlaces} />
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            {datosProceso !== null ? (
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                         INFORMACIÓN DEL PROCESO
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    <InformacionProcesoCorto
                      proceso={datosProceso}
                    ></InformacionProcesoCorto>
                  </div>
                  
                </div>
              </div>
            ) : (
              <></>
            )}

            <div className="col-xl-12 ">
              <div className="card ">
                <div className="card-header d-flex align-items-center">
                  <h3 className="card-title align-items-start flex-column ">
                    <span className="card-label fw-bolder text-dark ">
                      GESTIÓN DE NOTIFICACIONES EN PROCESO
                    </span>
                  </h3>
                  <button 
                  onClick={handleNotificar}
                  className={notificando? 'btn btn-info btn-sm disabled' : 'btn btn-info btn-sm'}><i className="fas fa-bell mr-2"></i>{notificando ? 'Notificando, espere un momento...': 'Notificar masivamente'}</button>
                </div>
                <div className="card-body ">
                  <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6 ">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-bs-toggle="tab"
                        href="#no-notificados"
                      >
                         No Notificados <span className="badge badge-warning">{cantidadNoNotificados}</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link "
                        data-bs-toggle="tab"
                        href="#notificados"
                      >
                         Notificados <span className="badge badge-success">{cantidadNotificados}</span>
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="tabruth">
                    <div
                      className="tab-pane fade show active"
                      id="no-notificados"
                      role="tabpanel"
                    >
                      <div className="table-responsive">
                        <table className="table table-rounded table-striped border gy-7 gs-7">
                          <thead>
                            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                              <th>Rut</th>
                              <th>Nombre</th>
                              <th>Dirección</th>
                              <th>Unidad</th>
                              <th>Precalificador</th>
                              <th>Verificar</th>
                            </tr>
                          </thead>
                          <tbody>
                            {datosSinCorreo !== null ? (
                              datosSinCorreo.map((dato, index) => {
                                return (
                                  <tr key={`trsin_${index}`}>
                                    <td>{dato.rutOfficer}</td>
                                    <td>{dato.nameOficcer}</td>
                                    <td>{dato.nameDmunicipal}</td>
                                    <td>{dato.nameUmunicipal}</td>
                                    <td>{dato.namePrequalifier}</td>
                                    <td>
                                      <button
                                        data-bs-toggle="modal"
                                        data-bs-target={`#modal`}
                                        onClick={handleVer}
                                        data-id={dato.id_participant}
                                        className="btn btn-secondary btn-sm"
                                      > VER</button>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td className="text-center" colSpan={6}>
                                  No hay datos para mostrar
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="notificados"
                      role="tabpanel"
                    >
                      <div className="table-responsive">
                        <table className="table table-rounded table-striped border gy-7 gs-7">
                          <thead>
                            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                              <th>Rut</th>
                              <th>Nombre</th>
                              <th>Dirección</th>
                              <th>Unidad</th>
                              <th>Precalificador</th>
                              <th>Verificar</th>
                            </tr>
                          </thead>
                          <tbody>
                            {datosNotificados !== null ? (
                              datosNotificados.map((dato, index) => {
                                return (
                                  <tr>
                                    <td>{dato.rutOfficer}</td>
                                    <td>{dato.nameOficcer}</td>
                                    <td>{dato.nameDmunicipal}</td>
                                    <td>{dato.nameUmunicipal}</td>
                                    <td>{dato.namePrequalifier}</td>
                                    <td>
                                      
                                      <NavLink
                                        to={`/verProcesoFuncionario/${idProcess}/${dato.id_participant}`}
                                        className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                                      >
                                         ver
                                      </NavLink>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td className="text-center" colSpan={6}>
                                  No hay datos para mostrar
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal id={`modal`} title={`INFORMACIÓN DEL FUNCIONARIO Y PROCESO`}>
        {infoParticipante}
      </Modal>
    </div>
  );
};
